import { Box, Button, Container, Link, Stack, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useHistory } from "react-router-dom";
import { scrollToSection, SECTION_IDS } from "../Header/MenuItem";

const SOCIAL_LINKS = [
  {
    href: "https://wa.me/7711800819",
    icon: WhatsAppIcon,
    label: "WhatsApp",
  },
  {
    href: "mailto:signacole2@gmail.com",
    icon: EmailIcon,
    label: "Correo",
  },
  {
    href: "https://facebook.com/signacole",
    icon: FacebookIcon,
    label: "Facebook",
  },
];

const Footer = () => {
  const history = useHistory();
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#1A3348",
        color: "#FFFFFF",
        pt: 8,
        pb: 4,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.4fr 1fr 1fr" },
            gap: 5,
            mb: 6,
          }}
        >
          <Box>
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL || ""}/img/logo.jpg`}
              alt="Signacole"
              width={110}
              height={104}
              loading="lazy"
              decoding="async"
              sx={{ height: 72, width: "auto", objectFit: "contain", mb: 2, bgcolor: "#fff", borderRadius: 1 }}
            />
            <Typography sx={{ color: "rgba(255,255,255,0.78)", mb: 3, maxWidth: 420 }}>
              ¿Tienes alguna pregunta? No dudes en contactarnos. Facilitamos la
              comunicación, la capacitación en LSM y el trabajo con la comunidad sorda.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href="https://wa.me/7711800819"
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<WhatsAppIcon />}
            >
              Hablar por WhatsApp
            </Button>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ color: "#FFFFFF", mb: 2 }}>
              Explorar
            </Typography>
            <Stack spacing={1.25} alignItems="flex-start">
              {[
                [SECTION_IDS.QUIENES_SOMOS, "Nosotros"],
                ["/cursos", "Cursos"],
                [SECTION_IDS.CURSOS1, "Servicios"],
                [SECTION_IDS.LIBRO, "Material"],
                ["/ticket", "Ticket"],
              ].map(([id, label]) => (
                <Button
                  key={id}
                  onClick={() => {
                    if (id.startsWith("/")) {
                      history.push(id);
                      window.scrollTo({ top: 0 });
                    } else if (history.location.pathname !== "/") {
                      history.push("/");
                      window.setTimeout(() => scrollToSection(id), 80);
                    } else {
                      scrollToSection(id);
                    }
                  }}
                  sx={{
                    color: "rgba(255,255,255,0.82)",
                    px: 0,
                    minHeight: 36,
                    justifyContent: "flex-start",
                    "&:hover": { color: "#FFFFFF", background: "transparent" },
                  }}
                >
                  {label}
                </Button>
              ))}
            </Stack>
          </Box>

          <Box id="contactos">
            <Typography variant="h6" sx={{ color: "#FFFFFF", mb: 2 }}>
              Contacto
            </Typography>
            <Stack spacing={1.5}>
              {SOCIAL_LINKS.map((link) => {
                const Icon = link.icon;
                return (
                  <Link
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 1,
                      color: "rgba(255,255,255,0.86)",
                      "&:hover": { color: "#FFFFFF" },
                    }}
                  >
                    <Icon fontSize="small" />
                    {link.label}
                  </Link>
                );
              })}
            </Stack>
          </Box>
        </Box>

        <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.12)", pt: 3 }}>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.62)", textAlign: "center" }}>
            © {new Date().getFullYear()} Signacole.{" "}
            <Link
              href="/cookies"
              sx={{
                color: "rgba(255,255,255,0.72)",
                "&:hover": { color: "#FFFFFF" },
              }}
            >
              Política de cookies
            </Link>
            {" · "}
            <Link
              href="https://www.ponchobt.dev/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "rgba(255,255,255,0.72)",
                "&:hover": { color: "#FFFFFF" },
              }}
            >
              sitio mantenido por PonchoBT.Dev
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
